export default class ApiNotifications {
    constructor(Restangular, ApiBaseResponseService) {
        let factory = {};

        factory.getNotifications = function() {
          return Restangular
                .one('notifications/number')
                .get()
                .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
        };

        return factory;
    }
}

ApiNotifications.inject = ['Restangular', 'ApiBaseResponseService'];



/** WEBPACK FOOTER **
 ** ./src/app/services/apiNotifications.js
 **/